import React, { Fragment } from "react";
import Label from "../../../../components/atoms/Label";
import LabelWithText from "../../../../components/molecules/LabelWithText";
import curencyFormat from "../../../../utils/helpers/curencyFormat";
import dateFormatIndo from "../../../../utils/helpers/dateFormatIndo";
import formatNumber from "../../../../utils/helpers/formatNumber";
import ButtonTTD from "../../ButtonTTD";

export default ({ title, dataDetail, LoanGrade, history }) => {
	let col = { label: "col-md-3", text: "col-md-9" };
	let filterLoanGrade = (grade) => {
		const value = LoanGrade.find(function (element) {
			return element.loanGrade === grade;
		});
		if (value) {
			return `(${value.minLoanRate}% - ${value.maxLoanRate}%)`;
		} else {
			return "";
		}
	};

	const getPinjamanCair = () => {
		const { loanAmount, provisionFee, otherFee } = dataDetail;
		const pinjamanCair = loanAmount - provisionFee - otherFee;

		return pinjamanCair;
	};

	return (
		<Fragment>
			<div className="container-title">
				<Label value={title} className="label-menu" />
			</div>
			<LabelWithText label={"Tipe Pinjaman"} text={dataDetail.loanTypeName || "-"} col={col} />
			<LabelWithText label={"Nilai Pinjaman"} text={`Rp ${dataDetail.loanAmount ? curencyFormat(dataDetail.loanAmount) : "-"}`} col={col} />
			<LabelWithText label={"Peringkat"} text={dataDetail.loanGrade ? `${dataDetail.loanGrade} ${filterLoanGrade(dataDetail.loanGrade)}` : "-"} col={col} />
			<LabelWithText label={"Suku Bunga Pinjaman"} text={`${dataDetail.loanRate ? formatNumber(dataDetail.loanRate, "", 2) : "-"}% p.a.`} col={col} />
			<LabelWithText label={"Persentase Biaya Layanan"} text={`${dataDetail.provisionFeePercentage ? formatNumber(dataDetail.provisionFeePercentage, "", 2) : "-"}%`} col={col} />
			<LabelWithText label={"Biaya Layanan"} text={`Rp ${dataDetail.provisionFee ? curencyFormat(dataDetail.provisionFee) : "-"}`} col={col} />
			<LabelWithText label={"Biaya Transaksi"} text={`Rp ${dataDetail.otherFee ? curencyFormat(dataDetail.otherFee) : "-"}`} col={col} />
			<LabelWithText label={"Nilai Pinjaman Dicairkan"} text={`Rp ${curencyFormat(getPinjamanCair())}`} col={col} />
			<LabelWithText label={"Tanggal Pencairan"} text={dataDetail.disburseDate ? dateFormatIndo(dataDetail.disburseDate, "long") : "-"} col={col} />
			<LabelWithText label={"Tanggal Jatuh Tempo"} text={dataDetail.loanDueDate ? dateFormatIndo(dataDetail.loanDueDate, "long") : "-"} col={col} />
			<LabelWithText label={"Suku Bunga Denda"} text={`${dataDetail.loanPenaltyRate ? formatNumber(dataDetail.loanPenaltyRate, "", 2) : "-"}% per hari`} col={col} />
			<LabelWithText label={"Nilai Bunga"} text={`Rp ${dataDetail.loanInterest ? curencyFormat(dataDetail.loanInterest) : "-"}`} col={col} />
			<LabelWithText label={"Nilai Denda"} text={`Rp ${dataDetail.loanPenalty ? curencyFormat(dataDetail.loanPenalty) : "-"}`} col={col} />
			<LabelWithText label={"Tanggal Pembayaran"} text={dataDetail.paymentDate ? dateFormatIndo(dataDetail.paymentDate, "long") : "-"} col={col} />
			<LabelWithText label={"Tanggal Akhir Pendanaan"} text={dataDetail.biddingEndDate ? dateFormatIndo(dataDetail.biddingEndDate, "long") : "-"} col={col} />
			{dataDetail.loanStatus === "PB0" && (
				<LabelWithText label={"Progres Pendanaan"} text={`Rp ${dataDetail.investedAmount ? curencyFormat(dataDetail.investedAmount) : "-"} / Rp ${dataDetail.loanAmount ? curencyFormat(dataDetail.loanAmount) : "-"}`} col={col} /> //investedAmount/
			)}
			{(dataDetail.loanStatus === "FL1" || dataDetail.loanStatus === "NPL") && <LabelWithText label={"Alasan Gagal"} text={dataDetail.failedReason || "-"} col={col} />}

			{/*Add Button Proses Tanda Tangan*/}
			{dataDetail.loanStatus === "AGR" && <ButtonTTD history={history} />}
		</Fragment>
	);
};
